import { Component, EventEmitter, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { customPatternValidator } from 'src/app/shared/custom-validator/pattern-validator';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  @Output() updateFrgtPwdStatus = new EventEmitter<any>();
  @Output() closeLogin = new EventEmitter<any>();
  forgotPwdForm: FormGroup;
  enableBtn: boolean = false;
  constructor(private _formBuilder: FormBuilder) {
    this.forgotPwdForm = this._formBuilder.group({
      email: [
        '',
        [Validators.required, customPatternValidator('email', 'email')],
      ],
    });
  }
  submitEmail() {
    this.updateFrgtPwdStatus.emit({
      status: false,
      email: this.forgotPwdForm.value.email,
    });
  }

  trimSpaces(field: string) {
    const emailValue = this.forgotPwdForm.value.email?.trim();
    this.forgotPwdForm.patchValue({ email: emailValue });
    if (this.forgotPwdForm.get('email')?.valid) {
      this.enableBtn = true;
    }
    else{
      this.enableBtn = false
    }
  }

  showLogin() {
    // this.router.navigateByUrl('/login');
    this.updateFrgtPwdStatus.emit({ status: false, email: null });
  }
}
